// eslint-disable-next-line import/prefer-default-export
export const muiFormControlLabelComponent = {
  styleOverrides: {
    labelPlacementEnd: ({ theme }) => ({
      alignItems: 'flex-start',
      columnGap: theme.spacing('XSMALL'),
      display: 'flex',
      margin: theme.spacing('NONE'),

      [`&.Mui-required > div`]: {
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'row-reverse',
      },

      [`&.Mui-disabled`]: {
        color: theme.palette.main.product_blue,
      },
    }),
    asterisk: {
      flexShrink: 0,
    },
  },
  variants: [
    {
      props: { variant: 'alignCenter' },
      style: () => ({
        alignItems: 'center',
      }),
    },
  ],
};
